import { Instance, types } from 'mobx-state-tree';

export const PhoneEntryConfig = types.model('PhoneEntryConfig', {
  maxLength: types.number,
  minLength: types.number,
  phonePrefix: types.maybe(types.string)
});

export type PhoneEntryConfig = Instance<typeof PhoneEntryConfig>;
